export default () => {
    Alpine.store('animationDelay', 0.3)
    Alpine.store('enterDelay', 1.1)

    Alpine.store('array', {
        remove(arr, value) {
            return arr.filter(ele => {
                return ele != value
            })
        },
    })

    Alpine.store('navigator', {
        open: false,
        animating: false,
        ministry: false,

        toggle() {
            if (!this.animating) {
                this.animating = true // End of animations set this to false
                this.open = !this.open
            }
        },
    })
}
